const serverBE = 'https://dev.crm.api.oncharge.it/api/v1';  //? BE DEV 

export const environment = { 

  environment: 'DEV',
  production: false,  
  dev: true,        //! DEV ENV
  uat: false,   
  
  
  
  baseFeUrl: 'https://dev.cpo.oncharge.it',
  baseServerURL: `${serverBE}/`,     
  HF_TOKEN : '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', 

  FLOWISE_TOKEN : 'adfBvhellXdzqI_adpIL6YD40a08ox7hlQJQpuur-Wc',

  VOICEFLOW_API_KEY_DEV: 'VF.DM.692c803c783cd5982705401a.gbBTj81wyMpNdhN7',   //* DEV
  VOICEFLOW_PROJECT_ID_DEV: '692c7f8faa64db708a89300b',                       //* DEV
  
  VOICEFLOW_API_KEY: 'VF.DM.687970817bff77f91143f78a.AmtAYTWWiSghCWBd',   //! PROD
  VOICEFLOW_PROJECT_ID: '68796f5b82a56722eb0d4bdf',                       //! PROD

  WHATSAPP_VERSION: 'v21.0',
  WHATSAPP_TOKEN: 'EAAQJctGZAl9IBO3LVQOBLZAARPxlZAKpjVO5jbuMsQ9XEJVTRx3ZCbbq4WHaMaJ9O8D2qIjKi7r4QLKA3JuRtaCSayWfqnFwmWWYwXaRiPRl6QgiTsIZCWPfpW8eFtuUw7MxBxWjZBpGZAZAX1LkZAO9FGFSZBZAgUOaHzVhvMxc3PgJptE2lAuaKW6OupoGFuJscmEqwZDZD',
  WHATSAPP_BUSINESS_ID: '471950669345523',
  WHATSAPP_NUMBER_ID: '526409377223805',
  WHATSAPP_PROD_NUMBER: '393514494901',
  WHATSAPP_DEV_NUMBER: '15551709978',  
  WHATSAPP_HUMAN_NUMBER: '390649779676', 

 
  WRAPPER_URL:  'https://ai-chatbot-backend-wrapper.oncharge.it', //^ WAS 'https://monta-api-wrapper.oncharge.it',
  WRAPPER_API_KEY: 'KFDAwwN4q9WkCDvQu5UxpEyuo7BBTdB2yP9XBrTMM8iuaEaWUU4JsFIuyCY0hYzx',

 
  WEBHOOK_URL: 'https://ai-chatbot-webhook.oncharge.it', //^ WAS 'https://metawh.oncharge.it' 
  
  FIREBASE_ENV: 'PROD',
  firebase: {
    apiKey: 'AIzaSyDHaS_SoRhf9nX3GZIn4eiCx1LWJ-e0WIg',
    databaseURL: 'https://zeus-7e655-default-rtdb.europe-west1.firebasedatabase.app',
    authDomain: 'zeus-7e655.firebaseapp.com',
    projectId: 'zeus-7e655',
    storageBucket: 'zeus-7e655.appspot.com',
    messagingSenderId: '74069116625',
    appId: '1:74069116625:web:3399dd2f51da7ab10167f0',
    measurementId: 'G-WBLKT9E1C4'
  },

  googleMapsApiKey: 'AIzaSyCjkQhKh9IrfCYNnve7vj_XlPGGT9LMa20' ,

  // sentry: {
  //   dsn: 'https://138dab8cb7294cd3e6163b12032a4c9f@o4506734805385216.ingest.sentry.io/4506734808399872'
  // }
};

